// ÐÐ°Ð½Ðº Ð¿Ð¾ ÐºÐ¾Ð´Ñ Ð²Ð½ÑÑÑÐ¸ ÐºÐ°Ð·Ð°ÑÑÑÐ°Ð½ÑÐºÐ¾Ð³Ð¾ IBAN.
//
// IBAN Ð Ð â 20 Ð·Ð½Ð°ÐºÐ¾Ð²: KZ, Ð´Ð²Ðµ ÐºÐ¾Ð½ÑÑÐ¾Ð»ÑÐ½ÑÐµ ÑÐ¸ÑÑÑ, ÑÑÐ¸ ÑÐ¸ÑÑÑ ÐºÐ¾Ð´Ð° Ð±Ð°Ð½ÐºÐ° Ð¸ 13
// Ð·Ð½Ð°ÐºÐ¾Ð² ÑÑÑÑÐ°. ÐÐ¾Ð´ Ð±Ð°Ð½ÐºÐ° Ð¿ÑÐ¸ÑÐ²Ð°Ð¸Ð²Ð°ÐµÑ ÐÐ°ÑÐ±Ð°Ð½Ðº, Ð¿ÑÐ¸ Ð¿ÐµÑÐµÐ¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ð¸ Ð±Ð°Ð½ÐºÐ° Ð¾Ð½ Ð½Ðµ
// Ð¼ÐµÐ½ÑÐµÑÑÑ (Ð¡Ð±ÐµÑÐ±Ð°Ð½Ðº â Bereke, Ð¦ÐµÑÐ½Ð°Ð±Ð°Ð½Ðº â Jusan â ÐºÐ¾Ð´Ñ Ð¿ÑÐµÐ¶Ð½Ð¸Ðµ).
//
// ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ñ â ÐºÐ°Ðº Ð¸Ñ Ð¿Ð¸ÑÑÑ Ð² Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°Ñ. ÐÐµÑ ÐºÐ¾Ð´Ð° Ð² ÑÐ¿Ð¸ÑÐºÐµ â Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð·Ð°Ð¿Ð¾Ð»Ð½ÑÐµÑ
// Ð±Ð°Ð½Ðº Ð¸ ÐÐÐ ÑÑÐºÐ°Ð¼Ð¸, ÐºÐ°Ðº ÑÐ°Ð½ÑÑÐµ.
export const KZ_BANKS = {
  601: { bic: 'HSBKKZKX', name: 'ÐÐ Â«ÐÐ°ÑÐ¾Ð´Ð½ÑÐ¹ ÐÐ°Ð½Ðº ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½Ð°Â»' },
  722: { bic: 'CASPKZKA', name: 'ÐÐ Â«Kaspi BankÂ»' },
  856: { bic: 'KCJBKZKX', name: 'ÐÐ Â«ÐÐ°Ð½Ðº Ð¦ÐµÐ½ÑÑÐÑÐµÐ´Ð¸ÑÂ»' },
  470: { bic: 'IRTYKZKA', name: 'ÐÐ Â«ForteBankÂ»' },
  435: { bic: 'SHBKKZKA', name: 'ÐÐ Â«Ð¨Ð¸Ð½ÑÐ°Ð½ ÐÐ°Ð½Ðº ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½Â»' },
  949: { bic: 'ATYNKZKA', name: 'ÐÐ Â«Altyn BankÂ»' },
  551: { bic: 'KSNVKZKA', name: 'ÐÐ Â«Freedom Bank KazakhstanÂ»' },
  914: { bic: 'BRKEKZKA', name: 'ÐÐ Â«Bereke BankÂ»' },
  948: { bic: 'EURIKZKA', name: 'ÐÐ Â«ÐÐ²ÑÐ°Ð·Ð¸Ð¹ÑÐºÐ¸Ð¹ Ð±Ð°Ð½ÐºÂ»' },
  826: { bic: 'TSESKZKA', name: 'ÐÐ Â«Jusan BankÂ»' },
  998: { bic: 'TSESKZKA', name: 'ÐÐ Â«Jusan BankÂ»' },
  886: { bic: 'INLMKZKA', name: 'ÐÐ Â«Home Credit BankÂ»' },
  849: { bic: 'NURSKZKX', name: 'ÐÐ Â«ÐÑÑÐ±Ð°Ð½ÐºÂ»' },
  821: { bic: 'KINCKZKA', name: 'ÐÐ Â«Bank RBKÂ»' },
  972: { bic: 'HCSKKZKA', name: 'ÐÐ Â«ÐÑÐ±Ð°ÑÑ Ð±Ð°Ð½ÐºÂ»' },
  563: { bic: 'KPSTKZKA', name: 'ÐÐ Â«ÐÐ°Ð·Ð¿Ð¾ÑÑÐ°Â»' },
  432: { bic: 'VTBAKZKZ', name: 'ÐÐ ÐÐ ÐÐ°Ð½Ðº ÐÐ¢Ð (ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½)' },
  832: { bic: 'CITIKZKA', name: 'ÐÐ Â«Ð¡Ð¸ÑÐ¸Ð±Ð°Ð½Ðº ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½Â»' },
  930: { bic: 'ICBKKZKX', name: 'ÐÐ Â«Ð¢Ð¾ÑÐ³Ð¾Ð²Ð¾-Ð¿ÑÐ¾Ð¼ÑÑÐ»ÐµÐ½Ð½ÑÐ¹ ÐÐ°Ð½Ðº ÐÐ¸ÑÐ°Ñ Ð² Ð³. ÐÐ»Ð¼Ð°ÑÑÂ»' },
  885: { bic: 'KZIBKZKA', name: 'ÐÐ Â«ÐÐ Â«ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½-ÐÐ¸ÑÐ°Ð°Ñ ÐÐ½ÑÐµÑÐ½ÐµÑÐ½Ð» ÐÐ°Ð½ÐºÂ»' },
  947: { bic: 'ALFAKZKA', name: 'ÐÐ Â«ÐÐ Â«ÐÐ»ÑÑÐ°-ÐÐ°Ð½ÐºÂ»' },
  246: { bic: 'HLALKZKZ', name: 'ÐÐ Â«ÐÑÐ»Ð°Ð¼ÑÐºÐ¸Ð¹ Ð±Ð°Ð½Ðº Â«Al HilalÂ»' },
  942: { bic: 'EXKAKZKA', name: 'ÐÐ Â«Ð­ÐºÑÐ¸Ð¼Ð±Ð°Ð½Ðº ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½Â»' },
  907: { bic: 'DVKAKZKA', name: 'ÐÐ Â«ÐÐ°Ð½Ðº Ð Ð°Ð·Ð²Ð¸ÑÐ¸Ñ ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½Ð°Â»' },
  125: { bic: 'NBRKKZKX', name: 'ÐÐ£ Â«ÐÐ°ÑÐ¸Ð¾Ð½Ð°Ð»ÑÐ½ÑÐ¹ ÐÐ°Ð½Ðº Ð ÐµÑÐ¿ÑÐ±Ð»Ð¸ÐºÐ¸ ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½Â»' },
};

/** IBAN Ð±ÐµÐ· Ð¿ÑÐ¾Ð±ÐµÐ»Ð¾Ð², Ð¼Ð°ÑÐºÐ¸ Ð¸ Ð² Ð²ÐµÑÑÐ½ÐµÐ¼ ÑÐµÐ³Ð¸ÑÑÑÐµ. */
export const normalizeIban = (value) =>
  String(value ?? '').replace(/[\s_-]/g, '').toUpperCase();

/**
 * ÐÐ¾Ð½ÑÑÐ¾Ð»ÑÐ½Ð°Ñ ÑÑÐ¼Ð¼Ð° IBAN (ISO 13616, Ð¾ÑÑÐ°ÑÐ¾Ðº 97 Ð¾Ñ Ð¿ÐµÑÐµÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð¿ÐµÑÐ²ÑÑ ÑÐµÑÑÑÑÑ
 * Ð·Ð½Ð°ÐºÐ¾Ð² Ð² ÐºÐ¾Ð½ÐµÑ). ÐÐ¾Ð²Ð¸Ñ Ð¾Ð¿ÐµÑÐ°ÑÐºÑ Ð² ÑÑÑÑÐµ Ð´Ð¾ ÑÐ¾Ð³Ð¾, ÐºÐ°Ðº Ð¿Ð»Ð°ÑÑÐ¶ ÑÐ¹Ð´ÑÑ Ð² Ð±Ð°Ð½Ðº.
 */
export const isValidIban = (value) => {
  const iban = normalizeIban(value);
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) return false;

  const rearranged = iban.slice(4) + iban.slice(0, 4);
  const digits = rearranged.replace(/[A-Z]/g, (ch) => String(ch.charCodeAt(0) - 55));

  // Ð§Ð¸ÑÐ»Ð¾ Ð´Ð»Ð¸Ð½Ð½ÐµÐµ, ÑÐµÐ¼ Ð²Ð»ÐµÐ·Ð°ÐµÑ Ð² double, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð´ÐµÐ»Ð¸Ð¼ Ð¿Ð¾ ÐºÑÑÐ¾ÑÐºÐ°Ð¼.
  let remainder = 0;
  for (const digit of digits) {
    remainder = (remainder * 10 + Number(digit)) % 97;
  }
  return remainder === 1;
};

/** ÐÐ°Ð½Ðº Ð¸ ÐÐÐ Ð¿Ð¾ IBAN. ÐÐµ ÐºÐ°Ð·Ð°ÑÑÑÐ°Ð½ÑÐºÐ¸Ð¹ ÑÑÑÑ Ð¸Ð»Ð¸ Ð½ÐµÐ·Ð½Ð°ÐºÐ¾Ð¼ÑÐ¹ ÐºÐ¾Ð´ â null. */
export const bankByIban = (value) => {
  const iban = normalizeIban(value);
  if (!/^KZ\d{2}\d{3}/.test(iban)) return null;
  return KZ_BANKS[Number(iban.slice(4, 7))] || null;
};

export default KZ_BANKS;
